export const RNA_TYPES = {
  codingRNA: Symbol.for('codingRNA'),
  lncRNA: Symbol.for('lncRNA'),
  circRNA: Symbol.for('circRNA'),
  miRNA: Symbol.for('miRNA'),
  piRNA: Symbol.for('piRNA'),
  tRFRNA: Symbol.for('tRFRNA'),
};
export const RNA_VALUES = {
  [RNA_TYPES.codingRNA]: 'coding',
  [RNA_TYPES.lncRNA]: 'lncRNA',
  [RNA_TYPES.circRNA]: 'circRNA',
  [RNA_TYPES.miRNA]: 'miRNA',
  [RNA_TYPES.piRNA]: 'piRNA',
  [RNA_TYPES.tRFRNA]: 'tRFRNA',
};
